import { ConfigProvider, Tabs } from "antd";
import React, { useRef } from "react";
import HTable from "./HTable";

const HTableWithTabs = React.memo(({ tabMenuItems, tabBarExtraContent, tableRef, defaultActiveKey, onChange, ui, data, toolbar, behavior, proProps }) => {
  const tableContainerRef = useRef(null);

  return (
    <div className="h-100" ref={tableContainerRef}>
      <ConfigProvider
        theme={{
          components: {
            Tabs: {
              colorPrimary: "var(--hs-violet)", // Active tab text color
              colorText: "#000000", // General text color
              inkBarColor: "var(--hs-violet)", // Active indicator color
              itemActiveColor: "#000000", // Text color for active tab
              itemHoverColor: "var(--hs-violet)", // Text color on hover
            },
          },
        }}
      >
        <Tabs
          className="hs-common-table-tabs p-1"
          tabBarExtraContent={tabBarExtraContent}
          defaultActiveKey={defaultActiveKey}
          onChange={onChange}
          items={tabMenuItems?.map((tab) => ({
            ...tab,
            children: (
              <HTable
                tableRef={tableRef}
                tableContainerRef={tableContainerRef}
                source="h-table-with-tabs"
                ui={ui}
                data={data}
                toolbar={toolbar}
                behavior={behavior}
                proProps={proProps}
              />
            ),
          }))}
        />
      </ConfigProvider>
    </div>
  );
});

export default HTableWithTabs;
